import { eachDayOfInterval } from "date-fns";
import { z } from "zod";

export const JumpToDateSchema = z.object({
    start_date: z.string().nonempty(),
    end_date: z.string().nonempty(),
}).superRefine((data, ctx) => {
    const startDate = new Date(data.start_date);
    const endDate = new Date(data.end_date);

    if (startDate > endDate) {
        ctx.addIssue({
            path: ['start_date'],
            code: z.ZodIssueCode.custom,
            message: 'Start date must be less than or equal to end date',
        })
    }

    if (eachDayOfInterval({ start: startDate, end: endDate }).length > 60 || eachDayOfInterval({ start: startDate, end: endDate }).length < 16) {
        ctx.addIssue({
            path: ['end_date'],
            code: z.ZodIssueCode.custom,
            message: 'Date range must be between 16 and 60 days',
        })
    }
});